<div class="db-google-sheet-connect-container">
  <p class="subtitle">Not ready? Explore now and connect later</p>
  <button class="cta-btn" (click)="goToGoogleSheet()">
    <div class="cta-text">Create a Dataset from a Google Sheet</div>
    <mode-capra-icon class="selection-arrow" icon="icon-control-edit-forward"></mode-capra-icon>
  </button>
  <a class="cta-btn sample-data-cta-btn" *ngIf="flowType === 'sign_up'" [href]="linkDest">
    <div class="cta-text">Start using Mode with sample data</div>
    <mode-capra-icon class="selection-arrow" icon="icon-control-edit-forward"></mode-capra-icon>
  </a>
</div>
